import { drawing } from '@progress/kendo-drawing';

export default function mousewheelDelta(e) {
    var delta = 0;

    if (e.wheelDelta) {
        delta = -e.wheelDelta / 120;
        delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
    }

    if (e.detail) {
        delta = drawing.util.round(e.detail / 3);
    }

    return delta;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/common/mousewheel-delta.js
// module id = 1897
// module chunks = 29